
/**
 * Explode a list of products with variants into a list of products
 * where each of the original variants from every product is its
 * own product object.
 *
 * @param {Array} products The array of products with included variants
 * @returns {Array} An array of products where each of the original variants is its own product
 */
export const explodeProducts = (products) => {
  let explodedProducts = [];

  products.forEach((product) => {
    // separate variant and data
    const { variants,  ...data } = product;

    variants.forEach((variant) => {
      // create new single variant product object
      let newProduct = {
        ...data,
        variants: [variant],
      };

      // ovverride variant-specific data
      if (variants.length > 1) {
        newProduct.title = `${data.title} ${variant.title}`;
        newProduct.url = `${data.url}?variant=${variant.id}`;
        newProduct.price = variant.price;

        if (variant.image) {
          newProduct.images.unshift(variant.image);
        }
      }

      explodedProducts.push(newProduct);
    });
  });

  return explodedProducts;
};

/**
 * Get a product's cleaned title (no roast level)
 *
 * @param {String} title: original product title
 *
 * @return {String}: cleaned title
 */
export const getProductCleanTitle = (title) => {
  if (!title.includes(' - ')) return title;
  return title.split(' - ')[0].trim();
};

/**
 * Get the discount percentage
 *
 * @param {Number} price The current price
 * @param {Number} comparePrice The compate at price
 * @returns {Number} The discount percentage
 */
export const getDiscountPercentage = (price, comparePrice) => {
  return Math.round(((comparePrice - price) / comparePrice) * 100);
};

/**
 * Get the final price of a product accounting for a discount percentage
 *
 * @param {Number} price The current price, in shopify price format i.e. 1100 for $11
 * @param {Number} discountPercentage The discount percentage as a whole number i.e. 20 for 20%
 */
export const getDiscountedPrice = (price, discountPercentage) => {
  const discountMultiplier = discountPercentage / 100;
  const discount = Math.round(price * discountMultiplier);

  return price - discount;
};
